import { Button, Modal, Paper } from "@mui/material";
import React from "react";

function InfoModal({infoOpen, handleInfoClose}) {
    return (<Modal open={infoOpen} onClose={handleInfoClose} style={{
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
  }}>
      <Paper sx={{
  width: 450,
  height: 330,
  bgcolor: 'background.paper',
  p: 2
  }}>
        <h2>Info</h2> 
        <p>
          Hey there! <b><em>VocaBuddy</em></b> is here to help you to store
            and practice you vocabulary. Simply add the words you are studying
          on the left side, then practice them on the right. 
        </p>
        <p>For any questions, suggestions and more, contact us at:</p>
        <p><u>vocabuddy1@gmail.com</u></p>
        <Button onClick={handleInfoClose}>Close</Button>
      </Paper>
  </Modal>);
}

export default InfoModal